<template>
  <div class="w100">
    <slot>
      <span v-if="label" class="title">{{ label }}：</span>
    </slot>
    <div v-if="!noTag" class="company-tag-box" style="overflow:hidden;">
      <el-tag
        v-for="(val, key) in value.keywords"
        :key="key"
        :type="val ? '' : 'info'"
        size="small"
        style="margin:0 4px 4px 0;cursor:pointer;font-size:14px"
        @click.native="clickLabel(key)"
        >{{ getTagLable(key) }}</el-tag
      >
    </div>
    <el-input
      v-model="value.content"
      type="textarea"
      :autosize="{ minRows: 2, maxRows: 18 }"
      :size="textAreaSize"
      :placeholder="label"
      @change="emit"
    ></el-input>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Object, default: () => ({ keywords: {}, content: '' }) },
    label: { type: String, default: '' },
    translate: { type: Object, default: () => ({}) },
    textAreaSize:{ type: String, default: 'mini' },
    noTag:{ type: Boolean, default: false },
  },
  data() {
    return {
      needToBeTranslate: false,
    }
  },
  mounted() {
    this.needToBeTranslate = Object.keys(this.translate).length > 0
  },
  methods: {
    getTagLable(key) {
      if (this.needToBeTranslate) return this.translate[key]
      else return key
    },
    clickLabel(key) {
      const val = this.value.keywords[key]
      this.value.keywords[key] = !val
      this.emit()
    },
    emit() {
      this.$emit('input', this.value)
    },
  },
}
</script>
<style scoped>
.w100 {
  width: 100%;
}
</style>
